import { render, staticRenderFns } from "./grid-router-link.vue?vue&type=template&id=3b1a9bb1&"
import script from "./grid-router-link.ts?vue&type=script&lang=js&"
export * from "./grid-router-link.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports